import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Pages/Home";
import Login from "./components/Pages/auth/Login";
import UsuarioCadastro from "./components/Pages/auth/UsuarioCadastro";
import Navbar from "./components/Layout/Navbar";
import BotaoInstalar from "./components/Layout/BotaoInstalar";
import Container from "./components/Layout/Container";
import { UsuarioProvider } from "./context/UsuarioContext";
import Mensagem from "./components/Layout/Mensagem";
import MenuLateral from "./components/Layout/MenuLateral/MenuLateral";
import PaginaNaoEncontrada from "./components/Pages/PaginaNaoEncontrada";
import EmpresaConsulta from "./components/Pages/empresa/EmpresaConsulta";
import EmpresaCadastro from "./components/Pages/empresa/EmpresaCadastro";
import EmprestimoConsulta from "./components/Pages/emprestimo/EmprestimoConsulta";
import EmprestimoCadastro from "./components/Pages/emprestimo/EmprestimoCadastro";
import EmprestimoDetalhe from "./components/Pages/emprestimo/EmprestimoDetalhe";
import RecebimentoConsulta from "./components/Pages/recebimento/RecebimentoConsulta";
import VisitaAgenda from "./components/Pages/visita/VisitaAgenda";
import AtendimentoIA from "./components/Pages/ia/AtendimentoIA";
import ProspeccaoPainel from "./components/Pages/prospeccao/ProspeccaoPainel";
import AmbienteTeste from "./components/Pages/teste/AmbienteTeste";
import CaixaConsulta from "./components/Pages/caixa/CaixaConsulta";
import DespesasPainel from "./components/Pages/despesas/DespesasPainel";
import ContabilidadePainel from "./components/Pages/contabilidade/ContabilidadePainel";
import DocumentoConsulta from "./components/Pages/documento/DocumentoConsulta";
import RelatorioDiario from "./components/Pages/relatorio/RelatorioDiario";
import ContratoImpressao from "./components/Pages/contrato/ContratoImpressao";
import EquipePainel from "./components/Pages/equipe/EquipePainel";
import Resgate from "./components/Pages/resgate/Resgate";
import RotaSecao from "./components/Layout/RotaSecao";

function AppComposicao(){
  const location = useLocation();

  // Páginas que mostram o menu lateral
  const semMenu = ['/login', '/cadastro-usuario'];
  const mostrarMenuLateral = !semMenu.includes(location.pathname) && !location.pathname.startsWith('/contrato/');

  return (
    <UsuarioProvider>
      <Navbar />
      <BotaoInstalar />
      <Mensagem msg="" tipo="" />
      <Container>
          { mostrarMenuLateral && <MenuLateral/> }
          <Routes>
            <Route path="/" element={<RotaSecao chave="dashboard"><Home /></RotaSecao>} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro-usuario" element={<UsuarioCadastro />} />
            <Route path="/empresas" element={<RotaSecao chave="empresas"><EmpresaConsulta /></RotaSecao>} />
            <Route path="/cadastro-empresa" element={<RotaSecao chave="empresas"><EmpresaCadastro /></RotaSecao>} />
            <Route path="/cadastro-empresa/:id" element={<RotaSecao chave="empresas"><EmpresaCadastro /></RotaSecao>} />
            <Route path="/emprestimos" element={<RotaSecao chave="emprestimos"><EmprestimoConsulta /></RotaSecao>} />
            <Route path="/cadastro-emprestimo" element={<RotaSecao chave="emprestimos"><EmprestimoCadastro /></RotaSecao>} />
            <Route path="/editar-emprestimo/:id" element={<RotaSecao chave="emprestimos"><EmprestimoCadastro /></RotaSecao>} />
            <Route path="/renovar-emprestimo/:id" element={<RotaSecao chave="emprestimos"><EmprestimoCadastro /></RotaSecao>} />
            <Route path="/emprestimo/:id" element={<RotaSecao chave="emprestimos"><EmprestimoDetalhe /></RotaSecao>} />
            <Route path="/contrato/:id" element={<ContratoImpressao />} />
            <Route path="/visitas" element={<RotaSecao chave="visitas"><VisitaAgenda /></RotaSecao>} />
            <Route path="/atendimento-ia" element={<RotaSecao chave="ia"><AtendimentoIA /></RotaSecao>} />
            <Route path="/prospeccao" element={<RotaSecao chave="prospeccao"><ProspeccaoPainel /></RotaSecao>} />
            <Route path="/ambiente-teste" element={<RotaSecao chave="teste"><AmbienteTeste /></RotaSecao>} />
            <Route path="/recebimentos" element={<RotaSecao chave="recebimentos"><RecebimentoConsulta /></RotaSecao>} />
            <Route path="/caixa" element={<RotaSecao chave="caixa"><CaixaConsulta /></RotaSecao>} />
            <Route path="/despesas" element={<RotaSecao chave="despesas"><DespesasPainel /></RotaSecao>} />
            <Route path="/contabilidade" element={<RotaSecao chave="contabilidade"><ContabilidadePainel /></RotaSecao>} />
            <Route path="/documentos" element={<RotaSecao chave="documentos"><DocumentoConsulta /></RotaSecao>} />
            <Route path="/relatorio" element={<RotaSecao chave="relatorio"><RelatorioDiario /></RotaSecao>} />
            <Route path="/equipe" element={<EquipePainel />} />
            <Route path="/resgate" element={<Resgate />} />
            <Route path="*" element={<PaginaNaoEncontrada />} />
          </Routes>
      </Container>
    </UsuarioProvider>
      )
}

function App() {
  return (
    <Router>
      <AppComposicao/>
    </Router>
  );
}

export default App;
